<div class="container-{{ size }}">
  @if (isSvg) {
  <mat-icon
    svgIcon="{{ icon }}"
    [ngClass]="{ icon: true, 'icon-selected': isSelected }"
    class="icon-{{ size }}"
    [style]="iconStyle"
  ></mat-icon>
  } @if (!isSvg) {
  <mat-icon
    [ngClass]="{ icon: true, 'icon-selected': isSelected }"
    class="icon-{{ size }}"
    [style]="iconStyle"
    >{{ icon }}</mat-icon
  >
  }
</div>
